<template>
    <div class="addonsListWrap">

        <ul v-if="productHasAddons(product.prices)">
            <vs-divider class="mt-6 mb-5"></vs-divider>

            <div class="flex addonsTitleWrap justify-between mb-1">
                <h5>Add-ons</h5>
                <h5>Price</h5>
            </div>
            <li v-for="(price, index) in product.prices"
                :key="index">

                <template v-if="price.custom_data &&
                            price.custom_data.type === 'addon' &&
                            price.custom_data.visible == 1">
                    <!-- Conditionally render rows for monthly and annual addons -->
                    <template v-if="price.billing_cycle">
                        <template v-if="monthlyAddonCondition(price.billing_cycle.interval) ||
                                        annuallyAddonCondition(price.billing_cycle.interval)">
                            <div class="addonsContWrap">
                                <div class="addonsNameWrap">
                                    <span>{{ price.name }}</span>
                                </div>
                                <template v-if="checkMultiplePrice(product)">
                                    <p v-if="price.unit_price.currency_code == priceCurrencyCode" class="addonsAmount">{{ getCurrencySymbol(price.unit_price.currency_code) }}{{ convertAmount(price.unit_price.amount) }}/<span>{{ price.billing_cycle.interval === 'month' ? 'mo' : 'yr' }}</span></p>
                                </template>
                                <template v-else>
                                    <p class="addonsAmount">{{ getCurrencySymbol(price.unit_price.currency_code) }}{{ convertAmount(price.unit_price.amount) }}/<span>{{ price.billing_cycle.interval === 'month' ? 'mo' : 'yr' }}</span></p>
                                </template>
                            </div>
                        </template>
                    </template>
                    <template v-else>
                        <div class="addonsContWrap">
                            <!-- One-time addon content goes here -->
                            <div class="addonsNameWrap">
                            <span>{{ price.name }}</span>
                            <span> (One Time)</span>
                            </div>

                            <template v-if="checkMultiplePrice(product)">
                                <p v-if="price.unit_price.currency_code == priceCurrencyCode" class="addonsAmount">{{ getCurrencySymbol(price.unit_price.currency_code) }}{{ convertAmount(price.unit_price.amount) }}</p>
                            </template>
                            <template v-else>
                                <p class="addonsAmount">{{ getCurrencySymbol(price.unit_price.currency_code) }}{{ convertAmount(price.unit_price.amount) }}</p>
                            </template>
                        </div>
                    </template>
                </template>
            </li>
        </ul>

    </div>
</template>

<script>
import { paddleMixin } from '@/mixins/paddle/paddle'

export default {
    mixins: [paddleMixin],
    components:{

    },
  props:{
        product:{
            type:Object,
            required:true,
            default:() => []
        },
        monthlyBilledTab:{
            type:Boolean,
            required:true,
            default:() => false
        },
        priceCurrencyCode:{
            type:String,
            required:true,
            default:() => 'GBP'
        },
    },
    data() {
        return {

        }
    },
    created() {

    },
    mounted () {

    },
    methods:{
            productHasAddons(prices) {
            // Use the 'some' method to check if any price meets the condition
            if (this.monthlyBilledTab) {
                return prices.some(price => {
                    return price.custom_data &&
                            price.custom_data.type === 'addon' &&
                            price.custom_data.visible == 1 &&
                            price.billing_cycle &&
                            price.billing_cycle.interval === 'month';
                });
            } else {
                return prices.some(price => {
                    return price.custom_data &&
                            price.custom_data.type === 'addon' &&
                            price.custom_data.visible == 1 &&
                            price.billing_cycle &&
                            price.billing_cycle.interval === 'year';
                });
            }
        },
        monthlyAddonCondition(interval) {
            return this.monthlyBilledTab && interval === 'month';
        },
        annuallyAddonCondition(interval) {
            return !this.monthlyBilledTab && interval === 'year';
        },

        checkMultiplePrice(product) {
            return product &&
                    product.custom_data &&
                    product.custom_data.multiPrice === 1;
        }
    }
}
</script>
<style scoped>
h5 {
    color: rgba(var(--vs-primary), 1) !important;
}
</style>